/* lua.js generated code 0.3.0 */

GameActionTargetType = table.const(table(
    [1, "kNone", 0],
    [1, "kGameBoardAction", 1],
    [1, "kGameItemAction", 2],
    [1, "kPropsAction", 3],
    [1, "kTargetAction", 4]
))
GameActionStatus = table.const(table(
    [1, "kNone", 0],
    [1, "kWaitingForStart", 1],
    [1, "kRunning", 2],
    [1, "kWaitingForDeath", 3]
))
GameBoardActionType = table.const(table(
    [1, "kStartTrySwapItem", 1],
    [1, "kStartTrySwapItemFailed", 2],
    [1, "kStartTrySwapItem_fun", 3],
    [1, "kStartBonusTime", 4],
    [1, "kStartBonusTime_ItemFlying", 5]
))
var GameItemActionTypeList = table.const(table(
    "kItemDeletedByMatch",
    "kItemSpecial_Line",
    "kItemSpecial_Column",
    "kItemSpecial_Cross",
    "kItemSpecial_Cross_Big",
    "kItemSpecial_Wrap",
    "kItemSpecial_Color",
    "kItemSpecial_Color_ItemDeleted",
    "kItemSpecial_ColorLine",
    "kItemSpecial_ColorLine_flying",
    "kItemSpecial_ColorWrap",
    "kItemSpecial_ColorWrap_flying",
    "kItemCoverBySpecial_Color",
    "kItemSpecial_ColorColor",
    "kItemSpecial_ColorColor_ItemDeleted",
    "kItemSpecial_WrapWrap",
    "kItemSpecial_WrapLine",
    "kItemSpecial_FourTile",
    "kItemSpecial_LineFourTile",
    "kItemSpecial_DoubleFourTile",
    "kItemSpecial_WrapFourTile",
    "kItemSpecial_ColorFourTile",
    "kItemSpecial_ColorFourTile_flying",
    "kItemSpecial_DoubleSuperBird",
    "kItemSpecial_SuperBirdBird",
    "kItemShakeBySpecialColor",
    "kItemFalling_UpDown",
    "kItemFalling_LeftRight",
    "kItemFalling_Product",
    "kItemFalling_Pass",
    "kItemMatchAt_IceDec",
    "kItemMatchAt_LockDec",
    "kItemScore_Get",
    "kItemScore_Bonus",
    "kItemRefresh_Item_Flying",
    "kItem_Crystal_Change",
    "kItem_Roost_Upgrade",
    "kItem_Roost_Replace",
    "kItem_Transmission",
    "kItem_Area_Destruction",
//     "kItem_Area_DestructionSpring2018",
    "kItem_Honey_Bottle_Broken",
    "kItemDestroy_HoneyDec",
    "kItem_Collection_by_Block",
    "kItem_Light_Up_Block",
    "kItem_Fish_Move",
    "kItem_Fish_Dec",
    "kItem_Fish_Back_Move_Pre",
    "kItem_Fish_Back_Move",
    "kItem_Circle_Collect",
    "kItem_Special_Item_By_Pet",
    "kItem_Warning_Item_By_Boss",
    "kItem_Block_Item_By_Boss",
    "kItem_Board_Color_Disappear",
    "kItem_Special_Super_Bird",
    "kItem_Special_Super_Bird_special",
    "kItemMatchAt_VarSnow",
    "kWoodBoxDec",
    "kItemMatchAt_BigBox",
    "kBigBoxBomb",
    "kItemMatchAt_FlowerVine",
    "kItem_FlowerVine_Delete",
    "kItem_Missile_Fly",
    "kFurballDec",
    "kFurballDecInvalid",
    "kFurballTransfer",
    "kFurballTransferFree",
    "kIceModeEnterStage",
    "kBlockCollect",
    "kWaterBombFire",
    "kWaterBombRotate",
    "kDandelionPlay",
    "kChangeAllItemToColor",
    "kItemMatchAt_Reef",
    "kItemMatchAt_SoilDec",
    "kDigWaterFlow",
    "kGridAnimBySpecial",
    "kChangeToSpecial",
    "kItem_VariousBox_Upgrade",
    "kItem_VariousBox_Replace",
    "kItem_Fish_Lock_Dec",
    "kBlockCollectCatch",
    "kBlockCollectionState",
    "kStarfishDec",
    "kStarfishEffectToBoss",
    "kWaterDigCollectBoat",
    "kBossBeatenByGameItem",
    "kBossChargePetsEnergy",
    "kBossBeatenByPet",
    "kTileMove",
    "kVenomDestroy",
    "kVenomSpread",
    "kCheckBoat4WaterDigScroll",
    "kWaterDigCollectBoatNoBlock",
    "kJellyfishDec",
    "kJellyfishRecovery",
    "kLighthouseDec",
    "kLighthouseAttackBoss",
    "kMagicSpread",
    "kSurfingCatConllision",
    "kPursueAttackIceChain",
    "kPursueAttackBlock",
    "kPursueGoAhead",
    "kPursueAddStrength",
    "kPursueReachTarget",
    "kColorCollectorConllision",
    "kItemSpecial_ColorCollector",
    "kSurpriseBoxConllision",
    "kSurpriseBoxDeferCollect",
    "kCakeDec",
    "kCakeBoom",
    "kJamBoxDec",
    "kJamBoxBoom",
    "kJamDec",
    "kAddJam",
    "kBlockMachineUpdate",
    "kBlockMachineBomb",
    "kCollectAnimalCoin",
    "kAnimalCoinProduct",
    "kIceCollectAnimation",
    "kBowknotDec",
    "kCollectCoin",
    "kAnimalScoreUpdate",
    "kShellDec",
    "kHammer_Big_Bomb",
    "kSuperHoneyBottleDec",
    "kAddHoney",
    "kItemDestroy_RiceBagDec",
    "kSodaCollectAnimation",
    "kGoldPackageDec",
    "kRiceBagEffectToBoss",
    "kCandyFlossDec",
    "kHedgehogDec",
    "kHedgehogRoll",
    "kHedgehogRollEnd",
    "kHedgehogOut",
    "kHedgehogOutAndAttack",
    "kHedgehogEffectToBoss",
    "kHedgehogDestroyDirect",
    "kItem_FlowerVine_Delete_One",
    "kWaterBoxDec",
    "kVulnerableDec",
    "kVulnerableProtect",
    "kDecCapsuleToy",
    "kItem_CapsuleToy_Replace",
    "kGrassCollect",
    "kLaserCollect",
    "kLaserFire",
    "kIceBombUpdateStep",
    "kIceBombDidBomb",
    "kCakeShooterFire",
    "kSharkFire",
    "kItemSpecial_XLine",
    "kGummyWormEat",
    "kGummyWormDestroy",
    "kGummyWormIdle",
    "kGummyWormDestroyDirect",
    "kHammer_Multi_Bomb",
    "kItemMatchAt_NestDoll",
    "kNestDoll_Degrade",
    "kNestDoll_Uncover",
    "kBlastCrystal_Blast",
    "kPlaneBomb",
    "kRocketDec",
    "kRocketReady",
    "kRocketSwap",
    "kRocketExplode",
    "kPropBlockUpdate",
    "kPropBlockDec",
    "kColoredFrostingDec",
    "kColoredFrostingShakeOnly",
    "kCandyYoyoDec",
    "kCandyYoyoRetract",
    "kJamJarDec",
    "kJamJarBomb",
    "kMintDec",
    "kSeaAnemoneDec",
    "kSeaAnemoneInc",
    "kMintSpray",
    "kMushroomDec",
    "kMushroomClear",
    "kFishnetDec",
    "kUFOMoveUp",
    "kUFOMoveOut",
    "kUFODec",
    "kUFOReplace",
    "kFlashBirdConllision",
    "kFlashBirdActive",
    "kFlashBirdBomb",
    "kDecCheeseRat",
    "kCheeseRatJump",
    "kCheeseRatCollect",
    "kPastryDec",
    "kPastryBoom",
    "kCroissantDec",
    "kMiniOctopusDec",
    "kMiniOctopusShow",
    "kFoamBombDec",
    "kFoamBombBomb",
    "kIcePopBoxDec",
    "kPopCanDec",
    "kItem_PopCan_Broken",
    "kFilbertDec",
    "kFilbertIdle",
    "kFireWorkFire",
    "kFireWorkFly",
    "kFireCrackerDec",
    "kFireCrackerReplace",
    "kIcecreamCollector_add",
    "kIcecreamCollector_block",
    "kIcecreamCollector_Bomb",
    "kItemMatchAt_IcecreamDec",
    "kLampLight",
    "kLampBomb",
    "kQualifyHatApear",
    "kCollectQualifyHat",
    "kEggDec",
    "kEggDecByColor",
    "kDyeChange",
    "kMagicbottleCollect",
    "kMagicbottleBomb",
    "kDinnertableCollect",
    "kBombCandyBomb",
    "kBombCandyDec",
    "kBombCandyShake",
    "kTorpedoCollect",
    "kTorpedoFire",
    "kBiscuitDec",
    "kMysteryIslandChargeEnergy",
    "kPopcornLittleBomb",
    "kPopcornBigBombPrepare",
    "kPopcornBigBomb",
    "kNestDec",
    "kHunterPrepare",
    "kHunterFire",
    "kDiamondDec",
    "kTurnTile_turn",
    "kTurnTileControl_dec",
    "kCannedFishDec",
    "kSafeDec",
    "kCircusBallConllision",
    "kCircusBallCollect",
    "kCircusAChangeToB",
    "kCircusBLightUp",
    "kCircusBActive",
    "kCircusBRemove",
    "kCandyCaneDec",
    "kCandyCaneDecJustClear",
    "kMangosteenDec",
    "kSupportStickDec",
    "kSupportStickBomb",
    "kResistShake"
))
GameItemActionType = table()
for (var k in GameItemActionTypeList) {
    var v = GameItemActionTypeList[k]
    if ($null(v)) continue
    GameItemActionType[v] = v
}
GamePropsActionType = table.const(table(
    [1, "kHammer", 1],
    [1, "kSwap", 2],
    [1, "kLineBrush", 3],
    [1, "kBack", 4],
    [1, "kOctopusForbid", 5],
    [1, "kRandomBird", 6],
    [1, "kBroom", 7],
    [1, "kLine", 8],
    [1, "kWrap", 9],
    [1, "kFourTile_b", 10],
    [1, "kSuperBird_b", 11],
    [1, "kLineAndWrap_b", 12],
    [1, "kWeeklyEnergy", 13],
    [1, "kHammer_big", 14],
    [1, "kBird_Cur_Level", 15],
    [1, "kLineReplace", 16],
    [1, "kPlane", 17],
    [1, "kRiverClean", 18],
    [1, "kDyeingAgent", 20],
    [1, "kHammerMultiHit", 21],
    [1, "kShockWave_1", 22],
    [1, "kLightUpDecProp", 23],
    [1, "kColumnDyeing", 24],
    [1, "kBombDyeing", 25],
    [1, "kIgnite", 26],
    [1, "kDice", 27],
    [1, "kColorBig", 28],
    [1, "kMirrorLevel_1", 29],
    [1, "kMirrorLevel_2", 30],
    [1, "kShockWave_2", 31],
    [1, "kBlastCrystalProp", 32],
    [1, "kBearWolf", 33],
    [1, "kSpecialAnimalReplace", 34],
    [1, "kMysteryIslandReplace", 35]

))
